<template>
  <ElDialog
    :title="$t('AUTH.STEPS.PUBLIC_PROFILE.DEVELOPER_TITLE_MODAL')"
    :visible="value"
    width="35%"
    @close="emitInputEvent"
  >
    <div class="row">
      <div class="column large-5">
        <img
          src="/images/developers-name-placement.png"
          class="public-profile__guidance-image"
        />
      </div>
      <div class="column large-7">
        {{ $t('AUTH.STEPS.PUBLIC_PROFILE.DEVELOPER_TITLE_MODAL_DESC') }}
      </div>
    </div>
  </ElDialog>
</template>

<script>
export default {
  name: 'DeveloperTitleGuideModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitInputEvent() {
      this.$emit('input', false);
    },
  },
};
</script>
